<!-- <ion-content >
  <ion-row >
    <ion-col >
      <iframe style="height: 100%;" width="100%" src="https://www.youtube.com/embed/CEaCDZosJ8w?autoplay=1&showinfo=0&controls=0" frameborder="0" allowfullscreen></iframe>
    </ion-col>
  </ion-row>
</ion-content> -->

<iframe *ngIf="didFetch && video && video.isSanitized" style="height: 100%;" width="100%" [src]="video.sanitizedUrl" frameborder="0" allowfullscreen></iframe>
<iframe *ngIf="didFetch && (!video || !video.isSanitized)" style="height: 100%;" width="100%" src="https://www.youtube.com/embed/5Cy-RRajKPg?autoplay=1&showinfo=0&controls=0" frameborder="0" allowfullscreen></iframe>
